<template>
  <div class="project-chunk">
    <!-- CV section -->
    <div class="flex-grid-two-column" :id=projectAnchor>
      <div class="sml-col"><h1 class="date-header">{{projectTitle}}</h1></div>
      <div class="col">
        <h1>{{projectHeader}}</h1>
        <h3>{{projectSubHead}}</h3>
        <slot name="projectContent"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProjectChunk',
  props: {
    projectAnchor: String,
    projectTitle: String,
    projectHeader: String,
    projectSubHead: String,
  }
}
</script>

<style scoped>
.date-header {
  position: -webkit-sticky;
  position: sticky;
  top: 0px;
}
.flex-grid {
  display: flex;
}
.col {
  flex: 1;
}

.flex-grid-two-column {
  display: flex;
  justify-content: space-between;
}

.flex-grid-two-column .col {
  width: 77%;
  text-align: left;
  padding-left: 3em;
  /* padding-right: 5em; */
}

.flex-grid-two-column .sml-col {
  width: 19%;
  text-align: left;
}

h1 {
  margin: 30px 0 30px 0;
}
h3 {
  margin: 40px 0 0;
}

img {
  height: 500px;
  width: 500px;
}
@media screen and (max-width: 500px) {
  .flex-grid {
    display: block;
  }

  .sml-col {
    word-wrap: break-word;
  }
  
  .sml-col h1 {
    font-size: 24px;
  }
  
  img {
    height: 250px;
    width: 205px;
  }
}

/* a {
    float: inherit; 
    color: #2a5286;
    text-align: center;
    text-decoration: none;
    padding-bottom: none;
    font-size: 18px; 
    line-height: 1em;
  }

  a:hover {
    color: black;
    border-bottom: 2px solid black;
  } */

  /* p {
    color: black;
  } */
</style>
